import React from 'react';
import './Chapters.scss';

function Chapter6() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          “This information is critical for accountability,” Oliveri points out. “Even if 95% of the
          supply chain is under our control and kept in the right condition, the 5% that isn’t can
          cause a great deal of trouble.” In the case of more delicate produce like raspberries,
          using serialized QR codes helps to track dwell time for individual lots—this data allows
          Perfection to act on supply-chain issues with incredible precision and fine-tune their
          distribution strategies like never before.
        </p>
        <p className="chapter__title">On the Horizon</p>
        <p className="chapter__paragraph">
          Even as these plump, perfectly ripe Kumatoes<sup>®</sup> finally reach their destinations
          and are neatly arranged on grocery shelves across Australia, Perfection knows there are no
          guarantees for the next crop, the next quarter, or the next big product idea. To stay
          competitive and relevant, a third and final class of data must be considered: consumer
          demand and satisfaction. To better forecast consumer behaviors, the company developed its
          own demand-planning program that helps them game out scenarios for specific products,
          places, and customers. These insights, combined with promotional sales trends, allow
          Perfection to develop a well-informed sales and supply plan, engage with their farms and
          growing partners, and build a robust supply to meet their targets.
        </p>
        <p className="chapter__paragraph">
          But because the goal is to utilize 100% of the crop yields, the company can’t simply be
          reactive to market conditions. They must be proactive in mitigating waste and loss. For a
          product like tomatoes, this can be accomplished by dividing the yields into separate
          grades for different end-users: bulk retail packaging, value packaging, and saucing, to
          name a few. For a product like cucumbers, it can be accomplished by identifying down-chain
          opportunities like pickling, which dramatically improves the product’s shelf life and
          stretches its value even further.
        </p>
      </section>
    </>
  );
}

export default Chapter6;
